import { render, staticRenderFns } from "./TableChallenges.vue?vue&type=template&id=68618ff5&"
import script from "./TableChallenges.vue?vue&type=script&lang=js&"
export * from "./TableChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports